export default __webpack_public_path__ + "static/media/eraser.0581326b.svg";